module.exports = __webpack_public_path__ + "img/map_picker_icon.512f16f6.svg";